// extracted by mini-css-extract-plugin
export default {"container":"fullImageView_container__vavkT","img":"fullImageView_img__D+f4F"};